import React from "react";
import classnames from "classnames";
import { connect } from 'react-redux';
import { withLocalize, Translate } from "react-localize-redux";
import { isNullOrUndefined } from '../../store/storeFunctions';
import { reportActions } from '../../store/reportStore';
import { bindActionCreators } from 'redux';
import AngleDownIcon from '../../img/icons/BBiconsRozbalit';
import BbCollapse from "./BbCollapse";

class OldStyleSection extends React.Component {

    state = {
        isOpen: this.props.isOpen || false,
        isExpandedTouched: false
    };

    componentDidMount() {
        if (!isNullOrUndefined(this.props.onClick)) {
            //used for loading subsections that are defined on server
            this.props.onClick();
        }
        this.props.sectionId && this.props.attachSectionElement(this.props.sectionId, this.holder);
    }

    componentDidUpdate(prevProps) {
        if (this.props.isExpandAllActivated !== prevProps.isExpandAllActivated || this.props.isHideAllActivated !== prevProps.isHideAllActivated) {
            this.setState({ isExpandedTouched: false });
        }
        if (this.props.sectionToFocus && this.props.sectionToFocus === this.props.sectionId) {
            this.setState({ isExpandedTouched: true, isOpen: true });
            this.props.sectionFocused();
            this.props.scrollToElement(this.props.elements[this.props.sectionToFocus], true, 'smooth')
        }
    }

    render() {
        const expanded = this.props.resolveExpanded(this.state.isOpen, this.state.isExpandedTouched);
        return (
            <div className={classnames('old-style-report-section', { 'is-expanded': expanded, 'old-style-no-data': !this.props.hasData })} ref={el => this.holder = el}>
                <div className="old-style-header-body" onClick={() => this.headerClick()}>
                    {this.renderIcon(this.props.hasData, expanded)}
                    <div style={{fontWeight: this.props.isBold && this.props.hasData ? "bold":"normal"}}>{this.props.name}</div>
                    {!this.props.hasData && !this.props.isReliability && <span style={{marginLeft:'auto'}}><Translate id='Report.Common.NoData' /></span>}
                    {this.props.isReliability && <span style={{marginLeft:'auto'}}><Translate id= {this.props.hasData ? 'Common.Yes' : 'Common.No'} /></span>}
                </div>
                { this.props.hasData && <BbCollapse className='old-style-report-section-body' tag="div" isOpen={expanded}>
                    {this.props.hasSpace && <div style={{ paddingTop: ".25em"}}></div>}
                    {this.props.children}
                </BbCollapse>}
            </div>
        )
    }
    renderIcon = (hasData, expanded) => {
        if(!hasData) {
            return <div className="icon-wrap"><span style={{fontWeight:this.props.isBold && this.props.hasData ? "bold":"normal", width:'1.4em', textAlign:'center', fontStyle:'normal'}}>O</span></div>;
        }
        return (
            <div className="icon-wrap">
                <AngleDownIcon
                    style={{ transform: `scaleY(${expanded ? -1 : 1})`, transition: 'all .5s ease', width: '1.4em', height: '1.4em' }}
                    className='svg-standard-fill' />
            </div>
        )
    }
    headerClick = () => {
        this.setState({ isExpandedTouched: true, isOpen: !this.props.resolveExpanded(this.state.isOpen, this.state.isExpandedTouched) })
        if (!isNullOrUndefined(this.props.onClick)) {
            //used for loading subsections that are defined on server
            this.props.onClick();
        }
    }
}


class OldStyleSection_StandAlone_Impl extends React.Component {

    state = {
        isOpen: this.props.isOpen || false,
        isExpandedTouched: false
    };

    render() {
        const expanded = this.state.isOpen;
        return (
            <div className={classnames('old-style-report-section', { 'is-expanded': expanded, 'old-style-no-data': !this.props.hasData })} ref={el => this.holder = el}>
                <div className="old-style-header-body" onClick={() => this.headerClick()}>
                    {this.renderIcon(this.props.hasData, expanded)}
                    <div style={{fontWeight: this.props.isBold && this.props.hasData ? "bold":"normal"}}>{this.props.name}</div>
                    {!this.props.hasData && <span style={{marginLeft:'auto'}}><Translate id='Report.Common.NoData' /></span>}
                </div>
                { this.props.hasData && <BbCollapse className='old-style-report-section-body' tag="div" isOpen={expanded}>
                    {this.props.hasSpace && <div style={{ paddingTop: ".25em"}}></div>}
                    {this.props.children}
                </BbCollapse>}
            </div>
        )
    }
    renderIcon = (hasData, expanded) => {
        if(!hasData) {
            return <div className="icon-wrap"><span style={{fontWeight:this.props.isBold && this.props.hasData ? "bold":"normal", width:'1.4em', textAlign:'center', fontStyle:'normal'}}>O</span></div>;
        }
        return (
            <div className="icon-wrap">
                <AngleDownIcon
                    style={{ transform: `scaleY(${expanded ? -1 : 1})`, transition: 'all .5s ease', width: '1.4em', height: '1.4em' }}
                    className='svg-standard-fill' />
            </div>
        )
    }
    headerClick = () => {
        this.setState({ isExpandedTouched: true, isOpen: !this.state.isOpen })
    }
}

export default OldStyleSection = withLocalize(connect(state => state.report, dispatch => bindActionCreators(reportActions, dispatch))(OldStyleSection));
export const OldStyleSection_StandAlone = withLocalize(OldStyleSection_StandAlone_Impl);